import { isNilOrEmpty } from './is-nil-or-empty';

// TODO: This isn't internationalized
export const decimalOnly = function(input: string | number) {
  if (isNilOrEmpty(input) || typeof input === 'number') {
    return input;
  }
  const digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  // Keeps track if a decimal point is used and only allows one.
  let hasDecimalPoint = false;

  const filteredChars = input.split('').filter((char) => {
    if (digits.includes(char)) {
      return true;
    }
    if (char === '.' && !hasDecimalPoint) {
      hasDecimalPoint = true;
      return true;
    }

    return false;
  });

  // Return it back as string
  return filteredChars.join('');
};
